import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initDiagScroll } from './utils/diagScroll';
import { anunciarNuevaVersion } from './components/AvisoNuevaVersion';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// AVISO-VERSION (2026-09-18): el registro del service worker tiene que correr ANTES que React,
// pero el aviso YA NO se pinta aqui con document.createElement. Eso lo dejaba fuera del arbol de
// React, donde nadie lo encuentra buscando — y por eso acabaron existiendo TRES banners distintos
// para lo mismo, dos de ellos muertos. Ahora esto solo avisa; quien pinta es
// components/AvisoNuevaVersion.js, que ademas se puede posponer y se ve bien en celular.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('[SW Update] Nueva version detectada');
    anunciarNuevaVersion(registration);
  },
  onSuccess: () => {
    console.log('[SW] Service Worker registrado y listo');
  },
});

reportWebVitals();

// Diagnostico EN VIVO de saltos de scroll: solo se activa si el flag esta encendido
// (se prende tocando 5 veces la version en el pie del menu de perfil). Apagado = nada.
initDiagScroll();

// ---------------------------------------------------------------------------
// MODO DIAGNOSTICO (?diagnostico=1): muestra en pantalla que VERSION del sitio
// tiene este telefono/navegador, para confirmar si esta corriendo lo ultimo o
// una version vieja en cache. Incluye boton para FORZAR actualizacion (borra
// caches + service workers + recarga). Se activa solo con ?diagnostico=1 en la
// URL; no aparece en el uso normal.
// ---------------------------------------------------------------------------
(function diagnosticoVersion() {
  try {
    if (!/[?&]diagnostico=1\b/.test(window.location.search)) return;
    if (document.getElementById('beep-diagnostico')) return;

    // Hash del bundle principal = identifica de forma unica la version desplegada.
    const mainScript = document.querySelector('script[src*="/static/js/main."]');
    const bundle = mainScript ? (mainScript.src.match(/main\.[a-f0-9]+\.js/) || ['?'])[0] : 'no detectado';

    const caja = document.createElement('div');
    caja.id = 'beep-diagnostico';
    caja.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;background:#0b2440;color:#fff;font-family:monospace;font-size:12px;line-height:1.5;padding:12px 14px;box-shadow:0 2px 10px rgba(0,0,0,.4);';
    caja.innerHTML =
      '<div style="font-weight:700;font-size:13px;margin-bottom:4px">Beep · diagnostico de version</div>' +
      '<div>Bundle: <b id="beep-diag-bundle">' + bundle + '</b></div>' +
      '<div id="beep-diag-sw">Version build: cargando…</div>' +
      '<div style="margin-top:8px;display:flex;gap:8px;flex-wrap:wrap">' +
        '<button id="beep-diag-refresh" style="background:#fff;color:#0b2440;border:none;border-radius:6px;padding:10px 14px;min-height:44px;font-size:14px;font-weight:700;font-family:inherit">Forzar actualizacion</button>' +
        '<button id="beep-diag-close" style="background:transparent;color:#fff;border:1px solid rgba(255,255,255,.5);border-radius:6px;padding:10px 14px;min-height:44px;font-size:14px;font-family:inherit">Cerrar</button>' +
      '</div>';
    document.body.appendChild(caja);

    // Lee la version del build desde el service-worker.js (trae Build ID + Timestamp).
    fetch('/service-worker.js?ts=' + Date.now(), { cache: 'no-store' })
      .then((r) => r.text())
      .then((txt) => {
        const bid = (txt.match(/Build ID:\s*([0-9]+)/) || [])[1] || '?';
        const ts = (txt.match(/Timestamp:\s*(.+)/) || [])[1] || '?';
        const el = document.getElementById('beep-diag-sw');
        if (el) el.innerHTML = 'Version build: <b>' + bid + '</b><br>Fecha build: <b>' + ts.trim() + '</b>';
      })
      .catch(() => {
        const el = document.getElementById('beep-diag-sw');
        if (el) el.textContent = 'Version build: no disponible (sin conexion)';
      });

    document.getElementById('beep-diag-close').addEventListener('click', () => caja.remove());
    document.getElementById('beep-diag-refresh').addEventListener('click', () => {
      const btn = document.getElementById('beep-diag-refresh');
      if (btn) { btn.textContent = 'Actualizando…'; btn.disabled = true; }
      const limpiar = [];
      if ('serviceWorker' in navigator) {
        limpiar.push(navigator.serviceWorker.getRegistrations().then((rs) => Promise.all(rs.map((r) => r.unregister()))).catch(() => {}));
      }
      if (window.caches && caches.keys) {
        limpiar.push(caches.keys().then((ks) => Promise.all(ks.map((k) => caches.delete(k)))).catch(() => {}));
      }
      Promise.all(limpiar).then(() => {
        // Recarga saltando cache: se le agrega un parametro anti-cache a la URL.
        const u = new URL(window.location.href);
        u.searchParams.set('_v', String(Date.now()));
        window.location.replace(u.toString());
      });
    });
  } catch (e) { /* diagnostico no debe romper la app nunca */ }
})();
